import styled from 'styled-components';
import { Icon } from '@usealloy/component-library';
import {
  DOT_MARGIN_FROM_NODE, DOT_SIZE, DOT_ICON_SIZE, DOT_RIGHT_PADDING,
} from './constants';

function deltaBetweenSizeAndMargin(side: number, margin: number) {
  return 100 * ((side + margin) / side);
}

interface DotContainerStyleProps {
  isVisible: boolean;
  isDisabled: boolean;
}
export const DotContainer = styled.div<DotContainerStyleProps>`
  align-items: center;
  cursor: ${({ isDisabled }) => (isDisabled ? 'not-allowed' : 'pointer')};
  display: flex;
  height: 100%;
  opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
  position: absolute;
  /* the padding fills the dead space between node and icon */
  padding-left: calc(${DOT_MARGIN_FROM_NODE}px + ${DOT_RIGHT_PADDING}px);
  padding-right: ${DOT_RIGHT_PADDING}px;
  right: calc(-${DOT_SIZE}px - ${DOT_MARGIN_FROM_NODE}px - ${DOT_RIGHT_PADDING}px);
  transform: ${({ isVisible }) => (isVisible
    ? 'translateX(0)'
    : `translateX(-${deltaBetweenSizeAndMargin(DOT_SIZE, DOT_MARGIN_FROM_NODE)}%)`)};
  transition: opacity 250ms ease-out, transform 250ms ease-out;
  `;

export const Dot = styled.div<{ isDisabled?: boolean }>`
  align-items: center;
  background-color: ${props => (props.isDisabled
    ? 'var(--cl-gray-500)'
    : 'var(--cl-juicyBlue-200)')};
  border-radius: 50%;
  display: flex;
  height: ${DOT_SIZE}px;
  justify-content: center;
  width: ${DOT_SIZE}px;
`;

export const DotIcon = styled(Icon) <{ isDisabled: boolean }>`
  color: ${props => (props.isDisabled
    ? 'var(--cl-gray-700)'
    : 'var(--cl-juicyBlue-500)')};
  height: ${DOT_ICON_SIZE}px;
  opacity: ${({ isDisabled }) => (!isDisabled ? 1 : 0.5)};
  width: ${DOT_ICON_SIZE}px;
`;
